import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'jernygateway';

class UserStateServiceAgent extends ServiceBase {
    /**
     * Fetches all UserState2 for the current user.
     * @returns {Promise}
     */
    getUserState2 = () => {
        const tabId = this.getTabId();
        const url = `${baseUrl}/${service}/user/state?tabId=${tabId}`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, config);
    };

    /**
     * Batch upsert user state entries.
     * Entries without RK are inserted (BE generates RK).
     * Entries with RK are updated.
     * @param {object} dto - { data: UserState2[] }
     * @returns {Promise}
     */
    postUserState = (dto) => {
        const url = `${baseUrl}/${service}/user/state`;
        const headers = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };
        return agent.post(url, dto, headers);
    };
}

const userStateService = new UserStateServiceAgent();
export default userStateService;
